import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { TestRouteSectionModel } from '../models/test-route-section.model';
import { SectionHeadlineComponent } from '../section-headline/section-headline.component';

@Component({
  selector: 'mb-test-route-section',
  templateUrl: './test-route-section.component.html',
  styleUrls: ['./test-route-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SectionHeadlineComponent, RouterLink, TranslatePipe],
})
export class TestRouteSectionComponent {
  @Input() data!: TestRouteSectionModel;
}
